import { Auth, authState, type User } from '@angular/fire/auth';
import { firstValueFrom, take } from 'rxjs';

export async function waitForAuthUser(auth: Auth): Promise<User | null> {
  if (auth.currentUser) {
    return auth.currentUser;
  }
  if (typeof auth.authStateReady === 'function') {
    await auth.authStateReady();
    return auth.currentUser;
  }
  return firstValueFrom(authState(auth).pipe(take(1)));
}
